import { render } from "./Index.vue?vue&type=template&id=783611c7"
import script from "./Index.vue?vue&type=script&setup=true&lang=js"
export * from "./Index.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/Reporting/Index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "783611c7"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('783611c7', __exports__)) {
    api.reload('783611c7', __exports__)
  }
  
  module.hot.accept("./Index.vue?vue&type=template&id=783611c7", () => {
    api.rerender('783611c7', render)
  })

}


export default __exports__